import React from 'react';
import PropTypes from 'prop-types';

import styles from './CSVModal.module.css';

const Loading = ({ type }) => (
  <div
    className={`${styles.content} ${
      type === 'addToCampaign' ? styles.addProducts : ''
    }`}
  >
    <div className={styles.loading}>
      <div className="fa-3x">
        <i className="fas fa-spinner-third fa-spin" />
      </div>
    </div>
  </div>
);

Loading.propTypes = {
  type: PropTypes.string.isRequired,
};

export default Loading;
